import {environment} from '@environments/environment';

export const traceLabBaseUrl: string = environment.traceLabUrl;
export const apiVersion = 'api-version=2.0';
